import * as React from 'react';

import { LeafletContext } from 'react-leaflet';
import { FitBoundsOptions, ZoomPanOptions } from 'leaflet';

import { LatLngTuple, LatLngBounds } from '@typings/geo';

import { defaultCenter, defaultZoom, maxBounds } from './map-context.constants';

export * from './map-context.constants';

export type MapContextType = {
  initialize: (leafletContext: LeafletContext) => void;
  initialized: boolean;
  loaded: boolean;
  satellite: boolean;
  setSatellite: (satellite: boolean) => void;
  zoom: number;
  zoomInDisabled: boolean;
  zoomOutDisabled: boolean;
  zoomIn: () => void;
  zoomOut: () => void;
  zoomTo: (center: LatLngTuple, zoom: number, options?: ZoomPanOptions) => void;
  center: LatLngTuple;

  on: (event: string, callback: () => void) => (() => void) | undefined;
  once: (event: string, callback: () => void) => void;
  setBounds: (bounds: LatLngBounds, opts?: FitBoundsOptions) => void;
  bounds: LatLngBounds;
};

export const MapContext = React.createContext<MapContextType>({
  initialize: () => {},
  satellite: false,
  loaded: false,
  initialized: false,
  setSatellite: () => {},
  zoom: defaultZoom,
  zoomInDisabled: false,
  zoomOutDisabled: false,
  zoomIn: () => {},
  zoomOut: () => {},
  zoomTo: () => {},
  center: defaultCenter,
  on: () => () => {},
  once: () => {},
  setBounds: () => {},
  bounds: maxBounds,
});
